import { useQuery } from "@tanstack/react-query";
import { fetchProfile, type Profile } from "@/lib/api/profile";

export function useProfile() {
  return useQuery<Profile>({
    queryKey: ["profile"],
    queryFn: fetchProfile,
    staleTime: 5 * 60_000,
  });
}
